import type {CSSProperties} from 'react';

export const GETTY_SOURCE_TAG_TOOLTIP_ID = 'getty-source-tag-tooltip';
export const SOURCE_TAG_TOOLTIP_VERTICAL_OFFSET = 8;

/* keep in sync with $tooltip-width in source-tag.module.scss */
export const SOURCE_TAG_TOOLTIP_WIDTH = 231;
export const SOURCE_TAG_TOOLTIP_VIEWPORT_MARGIN = 8;

export interface SourceTagProps {
  isPremium?: boolean;
}

export interface SourceTagTooltipPosition {
  left: number;
  top: number;
  arrowShift: number;
}

export interface SourceTagTooltipCSSProperties extends CSSProperties {
  '--source-tag-tooltip-arrow-shift': string;
}
